<template>
  <div :class="['expense-card', dark ? 'expense-card-dark' : 'expense-card-light']">
    <div class="expense-card-header">
      <i class="fas fa-calculator text-info" style="font-size: 22px"></i>
      <h3 class="mb-0 text-info expense-card-title">Resumo Financeiro</h3>
      <div class="expense-card-line" style="border-color: #17a2b8"></div>
    </div>

    <div class="row">
      <div class="col-md-3 mb-1" v-if="!isAdvance">
        <label :class="labelClass">Total solicitado</label>
        <div class="summary-value">{{ formatCurrency(totals.total_requested) }}</div>
      </div>
      <div class="col-md-3 mb-1" v-if="hasAdvance">
        <label :class="labelClass">Adiantamento</label>
        <div class="summary-value">{{ formatCurrency(totals.advance_amount) }}</div>
      </div>
      <div class="col-md-3 mb-1">
        <label :class="labelClass">Total aprovado</label>
        <div class="summary-value">{{ formatCurrency(totals.total_approved) }}</div>
      </div>

      <!-- Com adiantamento o saldo indica quem devolve; sem adiantamento é o valor a reembolsar -->
      <div class="col-md-3 mb-1" v-if="hasAdvance">
        <label :class="labelClass">Saldo</label>
        <div class="summary-value">{{ formatCurrency(Math.abs(totals.balance_to_receive)) }}</div>
        <span v-if="totals.balance_to_receive > 0" class="text-danger">(Devolver à IT4D)</span>
        <span v-else-if="totals.balance_to_receive < 0" class="text-success">(Devolver ao Colaborador)</span>
        <span v-else class="text-muted">(Sem saldo a acertar)</span>
      </div>
      <div class="col-md-3 mb-1" v-else>
        <label :class="labelClass">Valor a reembolsar</label>
        <div class="summary-value">{{ formatCurrency(totals.total_approved) }}</div>
      </div>

      <div class="col-md-3 mb-1" v-if="reviewing">
        <label :class="labelClass">Despesas pendentes</label>
        <div class="summary-value">{{ totals.pending_items }}</div>
      </div>
    </div>

    <!-- Durante a análise os valores consideram só as despesas já aprovadas -->
    <div v-if="inReview" class="alert alert-info p-1 mt-1 mb-0">
      <i class="fas fa-info-circle mr-50"></i>
      <template v-if="hasAdvance">
        O valor de Saldo poderá ser alterado após a aprovação ou rejeição de cada despesa.
        Ele considera apenas as despesas já aprovadas.
      </template>
      <template v-else>
        O valor a reembolsar poderá ser alterado após a aprovação ou rejeição de cada despesa.
        Ele considera apenas as despesas já aprovadas.
      </template>
    </div>

    <div class="text-right mt-1" v-if="reviewing">
      <small v-if="totals.pending_items > 0" class="text-muted mr-1">
        Aprove ou rejeite todas as despesas para concluir.
      </small>
      <button class="btn btn-primary" :disabled="totals.pending_items > 0" @click="$emit('conclude')">
        <i class="fas fa-flag-checkered"></i> Concluir análise
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Resumo financeiro compartilhado por adiantamento e reembolso.
 * totals vem da API: advance_amount, total_requested, total_approved, balance_to_receive, pending_items.
 */
export default {
  name: "FinancialSummary",
  props: {
    totals: { type: Object, required: true },
    // "advance" (adiantamento) ou "reimbursement" (reembolso comum)
    mode: { type: String, default: "reimbursement" },
    // quem pode analisar: mostra pendentes e o botão "Concluir análise"
    reviewing: { type: Boolean, default: false },
    // a solicitação está em análise: mostra o aviso de que os valores podem mudar
    inReview: { type: Boolean, default: false },
  },
  computed: {
    dark() {
      return this.$store.state.appConfig.layout.skin === "dark";
    },
    labelClass() {
      return this.dark ? "expense-label-dark" : "expense-label-light";
    },
    isAdvance() {
      return this.mode === "advance";
    },
    hasAdvance() {
      // Reembolsos antigos podem ter valor de adiantamento informado
      return this.isAdvance || Number(this.totals.advance_amount) > 0;
    },
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(value) || 0);
    },
  },
};
</script>

<style scoped src="./expense-card.css"></style>
<style scoped>
.summary-value {
  font-size: 18px;
  font-weight: 700;
}
</style>
